/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { GetAllAutoSaveStatusesOkDto } from '../../src/model';
// @ts-ignore
import type { GetAutoSaveReqParamDto } from '../../src/model';
// @ts-ignore
import type { GetAutoSaveStatusByViewupSnsAccountUuidOkDto } from '../../src/model';
// @ts-ignore
import type { GetAutoSaveStatusOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { PatchAutoSaveBadRequestDto } from '../../src/model';
// @ts-ignore
import type { PatchAutoSaveForbiddenDto } from '../../src/model';
// @ts-ignore
import type { PatchAutoSaveStatusReqBodyDto } from '../../src/model';
/**
 * AutoSaveApi - axios parameter creator
 * @export
 */
export const AutoSaveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 모두그램에서 호출: 자동적립 계정 조회 (뷰업, 뷰업플러스 계정)
         * @param {string} typeCode 타입 코드
         * @param {Array<string>} viewingUuids 서버에서 적립하려는 뷰잉 uuid
         * @param {boolean} [isActivity] 활동기능 여부
         * @param {AutoSaveControllerGetAccountGenderEnum} [gender] 성별
         * @param {number} [age] 나이
         * @param {number} [count] 필요한 아이디 개수
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoSaveControllerGetAccount: async (typeCode: string, viewingUuids: Array<string>, isActivity?: boolean, gender?: AutoSaveControllerGetAccountGenderEnum, age?: number, count?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeCode' is not null or undefined
            assertParamExists('autoSaveControllerGetAccount', 'typeCode', typeCode)
            // verify required parameter 'viewingUuids' is not null or undefined
            assertParamExists('autoSaveControllerGetAccount', 'viewingUuids', viewingUuids)
            const localVarPath = `/auto-save/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typeCode !== undefined) {
                localVarQueryParameter['typeCode'] = typeCode;
            }

            if (isActivity !== undefined) {
                localVarQueryParameter['isActivity'] = isActivity;
            }

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (age !== undefined) {
                localVarQueryParameter['age'] = age;
            }

            if (viewingUuids) {
                localVarQueryParameter['viewingUuids'] = viewingUuids;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 모두그램에서 호출: 모든 자동적립 상태 계정 조회 (뷰업, 뷰업플러스 계정)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoSaveControllerGetAllAutoSaveStatuses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auto-save/modoogram`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 로그인한 유저 자동적립 상태 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoSaveControllerGetAutoSaveStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auto-save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SNS 계정 자동적립 상태 조회
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {GetAutoSaveReqParamDto} [getAutoSaveReqParamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuid: async (snsAccountUuid: string, getAutoSaveReqParamDto?: GetAutoSaveReqParamDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snsAccountUuid' is not null or undefined
            assertParamExists('autoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuid', 'snsAccountUuid', snsAccountUuid)
            const localVarPath = `/auto-save/{snsAccountUuid}`
                .replace(`{${"snsAccountUuid"}}`, encodeURIComponent(String(snsAccountUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAutoSaveReqParamDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SNS 계정 자동적립 상태 변경
         * @param {PatchAutoSaveStatusReqBodyDto} patchAutoSaveStatusReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoSaveControllerPatchAutoSaveStatus: async (patchAutoSaveStatusReqBodyDto: PatchAutoSaveStatusReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patchAutoSaveStatusReqBodyDto' is not null or undefined
            assertParamExists('autoSaveControllerPatchAutoSaveStatus', 'patchAutoSaveStatusReqBodyDto', patchAutoSaveStatusReqBodyDto)
            const localVarPath = `/auto-save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchAutoSaveStatusReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoSaveControllerPpapppapppappPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auto-save/ppapppapppapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AutoSaveApi - functional programming interface
 * @export
 */
export const AutoSaveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AutoSaveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 모두그램에서 호출: 자동적립 계정 조회 (뷰업, 뷰업플러스 계정)
         * @param {string} typeCode 타입 코드
         * @param {Array<string>} viewingUuids 서버에서 적립하려는 뷰잉 uuid
         * @param {boolean} [isActivity] 활동기능 여부
         * @param {AutoSaveControllerGetAccountGenderEnum} [gender] 성별
         * @param {number} [age] 나이
         * @param {number} [count] 필요한 아이디 개수
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoSaveControllerGetAccount(typeCode: string, viewingUuids: Array<string>, isActivity?: boolean, gender?: AutoSaveControllerGetAccountGenderEnum, age?: number, count?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoSaveControllerGetAccount(typeCode, viewingUuids, isActivity, gender, age, count, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutoSaveApi.autoSaveControllerGetAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 모두그램에서 호출: 모든 자동적립 상태 계정 조회 (뷰업, 뷰업플러스 계정)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoSaveControllerGetAllAutoSaveStatuses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllAutoSaveStatusesOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoSaveControllerGetAllAutoSaveStatuses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutoSaveApi.autoSaveControllerGetAllAutoSaveStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 로그인한 유저 자동적립 상태 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoSaveControllerGetAutoSaveStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAutoSaveStatusOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoSaveControllerGetAutoSaveStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutoSaveApi.autoSaveControllerGetAutoSaveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary SNS 계정 자동적립 상태 조회
         * @param {string} snsAccountUuid sns 계정 uuid
         * @param {GetAutoSaveReqParamDto} [getAutoSaveReqParamDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuid(snsAccountUuid: string, getAutoSaveReqParamDto?: GetAutoSaveReqParamDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAutoSaveStatusByViewupSnsAccountUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuid(snsAccountUuid, getAutoSaveReqParamDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutoSaveApi.autoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary SNS 계정 자동적립 상태 변경
         * @param {PatchAutoSaveStatusReqBodyDto} patchAutoSaveStatusReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoSaveControllerPatchAutoSaveStatus(patchAutoSaveStatusReqBodyDto: PatchAutoSaveStatusReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAutoSaveStatusByViewupSnsAccountUuidOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoSaveControllerPatchAutoSaveStatus(patchAutoSaveStatusReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutoSaveApi.autoSaveControllerPatchAutoSaveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoSaveControllerPpapppapppappPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoSaveControllerPpapppapppappPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutoSaveApi.autoSaveControllerPpapppapppappPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AutoSaveApi - factory interface
 * @export
 */
export const AutoSaveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AutoSaveApiFp(configuration)
    return {
        /**
         * 
         * @summary 모두그램에서 호출: 자동적립 계정 조회 (뷰업, 뷰업플러스 계정)
         * @param {AutoSaveApiAutoSaveControllerGetAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoSaveControllerGetAccount(requestParameters: AutoSaveApiAutoSaveControllerGetAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.autoSaveControllerGetAccount(requestParameters.typeCode, requestParameters.viewingUuids, requestParameters.isActivity, requestParameters.gender, requestParameters.age, requestParameters.count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 모두그램에서 호출: 모든 자동적립 상태 계정 조회 (뷰업, 뷰업플러스 계정)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoSaveControllerGetAllAutoSaveStatuses(options?: RawAxiosRequestConfig): AxiosPromise<GetAllAutoSaveStatusesOkDto> {
            return localVarFp.autoSaveControllerGetAllAutoSaveStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 로그인한 유저 자동적립 상태 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoSaveControllerGetAutoSaveStatus(options?: RawAxiosRequestConfig): AxiosPromise<GetAutoSaveStatusOkDto> {
            return localVarFp.autoSaveControllerGetAutoSaveStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SNS 계정 자동적립 상태 조회
         * @param {AutoSaveApiAutoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuid(requestParameters: AutoSaveApiAutoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAutoSaveStatusByViewupSnsAccountUuidOkDto> {
            return localVarFp.autoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuid(requestParameters.snsAccountUuid, requestParameters.getAutoSaveReqParamDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SNS 계정 자동적립 상태 변경
         * @param {AutoSaveApiAutoSaveControllerPatchAutoSaveStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoSaveControllerPatchAutoSaveStatus(requestParameters: AutoSaveApiAutoSaveControllerPatchAutoSaveStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAutoSaveStatusByViewupSnsAccountUuidOkDto> {
            return localVarFp.autoSaveControllerPatchAutoSaveStatus(requestParameters.patchAutoSaveStatusReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoSaveControllerPpapppapppappPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.autoSaveControllerPpapppapppappPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for autoSaveControllerGetAccount operation in AutoSaveApi.
 * @export
 * @interface AutoSaveApiAutoSaveControllerGetAccountRequest
 */
export interface AutoSaveApiAutoSaveControllerGetAccountRequest {
    /**
     * 타입 코드
     * @type {string}
     * @memberof AutoSaveApiAutoSaveControllerGetAccount
     */
    readonly typeCode: string

    /**
     * 서버에서 적립하려는 뷰잉 uuid
     * @type {Array<string>}
     * @memberof AutoSaveApiAutoSaveControllerGetAccount
     */
    readonly viewingUuids: Array<string>

    /**
     * 활동기능 여부
     * @type {boolean}
     * @memberof AutoSaveApiAutoSaveControllerGetAccount
     */
    readonly isActivity?: boolean

    /**
     * 성별
     * @type {'M' | 'F' | 'unknown'}
     * @memberof AutoSaveApiAutoSaveControllerGetAccount
     */
    readonly gender?: AutoSaveControllerGetAccountGenderEnum

    /**
     * 나이
     * @type {number}
     * @memberof AutoSaveApiAutoSaveControllerGetAccount
     */
    readonly age?: number

    /**
     * 필요한 아이디 개수
     * @type {number}
     * @memberof AutoSaveApiAutoSaveControllerGetAccount
     */
    readonly count?: number
}

/**
 * Request parameters for autoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuid operation in AutoSaveApi.
 * @export
 * @interface AutoSaveApiAutoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuidRequest
 */
export interface AutoSaveApiAutoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuidRequest {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof AutoSaveApiAutoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuid
     */
    readonly snsAccountUuid: string

    /**
     * 
     * @type {GetAutoSaveReqParamDto}
     * @memberof AutoSaveApiAutoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuid
     */
    readonly getAutoSaveReqParamDto?: GetAutoSaveReqParamDto
}

/**
 * Request parameters for autoSaveControllerPatchAutoSaveStatus operation in AutoSaveApi.
 * @export
 * @interface AutoSaveApiAutoSaveControllerPatchAutoSaveStatusRequest
 */
export interface AutoSaveApiAutoSaveControllerPatchAutoSaveStatusRequest {
    /**
     * 
     * @type {PatchAutoSaveStatusReqBodyDto}
     * @memberof AutoSaveApiAutoSaveControllerPatchAutoSaveStatus
     */
    readonly patchAutoSaveStatusReqBodyDto: PatchAutoSaveStatusReqBodyDto
}

/**
 * AutoSaveApi - object-oriented interface
 * @export
 * @class AutoSaveApi
 * @extends {BaseAPI}
 */
export class AutoSaveApi extends BaseAPI {
    /**
     * 
     * @summary 모두그램에서 호출: 자동적립 계정 조회 (뷰업, 뷰업플러스 계정)
     * @param {AutoSaveApiAutoSaveControllerGetAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutoSaveApi
     */
    public autoSaveControllerGetAccount(requestParameters: AutoSaveApiAutoSaveControllerGetAccountRequest, options?: RawAxiosRequestConfig) {
        return AutoSaveApiFp(this.configuration).autoSaveControllerGetAccount(requestParameters.typeCode, requestParameters.viewingUuids, requestParameters.isActivity, requestParameters.gender, requestParameters.age, requestParameters.count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 모두그램에서 호출: 모든 자동적립 상태 계정 조회 (뷰업, 뷰업플러스 계정)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutoSaveApi
     */
    public autoSaveControllerGetAllAutoSaveStatuses(options?: RawAxiosRequestConfig) {
        return AutoSaveApiFp(this.configuration).autoSaveControllerGetAllAutoSaveStatuses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 로그인한 유저 자동적립 상태 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutoSaveApi
     */
    public autoSaveControllerGetAutoSaveStatus(options?: RawAxiosRequestConfig) {
        return AutoSaveApiFp(this.configuration).autoSaveControllerGetAutoSaveStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SNS 계정 자동적립 상태 조회
     * @param {AutoSaveApiAutoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutoSaveApi
     */
    public autoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuid(requestParameters: AutoSaveApiAutoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuidRequest, options?: RawAxiosRequestConfig) {
        return AutoSaveApiFp(this.configuration).autoSaveControllerGetAutoSaveStatusByViewupSnsAccountUuid(requestParameters.snsAccountUuid, requestParameters.getAutoSaveReqParamDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SNS 계정 자동적립 상태 변경
     * @param {AutoSaveApiAutoSaveControllerPatchAutoSaveStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutoSaveApi
     */
    public autoSaveControllerPatchAutoSaveStatus(requestParameters: AutoSaveApiAutoSaveControllerPatchAutoSaveStatusRequest, options?: RawAxiosRequestConfig) {
        return AutoSaveApiFp(this.configuration).autoSaveControllerPatchAutoSaveStatus(requestParameters.patchAutoSaveStatusReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutoSaveApi
     */
    public autoSaveControllerPpapppapppappPost(options?: RawAxiosRequestConfig) {
        return AutoSaveApiFp(this.configuration).autoSaveControllerPpapppapppappPost(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AutoSaveControllerGetAccountGenderEnum = {
    M: 'M',
    F: 'F',
    Unknown: 'unknown'
} as const;
export type AutoSaveControllerGetAccountGenderEnum = typeof AutoSaveControllerGetAccountGenderEnum[keyof typeof AutoSaveControllerGetAccountGenderEnum];
